import React from 'react';

export const SingleTrack = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__b)"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path
          d="M58.9 49.5s0 0 0 0c.5-.5.9-1.3 1.1-2.4l-7.6 2.5c2 .6 3.5.8 4.6.7 0 0 0 0 0 0 .8.3 3.4 3 .9 4.4-4.6 1.2-3-4.2-3-4.2l-1.5-.2c-.1 3.5.7 7.4 4.6 6.6 3.5-1.1 2.7-5.1.9-7.4z"
          fill="#233762"
        />
        <path fill="#fff" d="M-33.1 66.6L78.3 33.5l-8.4-5.6-105.7 28.9z" />
        <path fill="#8291ae" d="M-34.7 77.3l111.1-36 1.9-7.8-111.4 33.1z" />
        <path
          d="M33.5 58.4s0 0 0 0c.5-.5.9-1.3 1.1-2.4L27 58.5c2 .6 3.5.8 4.6.7 0 0 0 0 0 0 .8.3 3.4 3 .9 4.4-4.6 1.2-3-4.2-3-4.2l-1.5-.2c-.1 3.5.7 7.4 4.6 6.6 3.5-1.2 2.7-5.1.9-7.4z"
          fill="#233762"
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
